import { Card } from "reactstrap";
import boxRider from "../../../../assets/images/ayeza-khan-img.png";
import Stars from "../../../../assets/images/StarIcon.png";
import NoStars from "../../../../assets/images/no-selected-star.png";
import Cap from "../../../../assets/images/cap.png";
import commentIcon from "../../../../assets/images/Comment-Icon.png";
import { useEffect, useState } from "react";
import ReviewReplyModal from "./ReviewReplyModal";
import DisputeModal from "./DisputeModal";
import ChatDisable from "../../../../assets/chatdisable.png";
import ImageViewer from "Components/Common/ImageViewer";
import profile from "../../../../assets/images/userProfile.png";
import ErrorModal from "Components/Common/ErrorModal";


const OrderReviewCard = (props: any) => {
  var reviewData = props?.reviews;
  const [errorMessage, setErrorMessage] = useState<string>("");

  const [showModal, setShowModal] = useState({
    isVisible: false,
    color: false,
  });

  useEffect(() => {
    console.log(props.reviews, "reviews");
  }, []);

  const formatDate = (timestamp: number) => {
    const date = new Date(timestamp);

    const formattedDate = date.toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });

    const formattedTime = date.toLocaleTimeString("en-GB", {
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });

    return { formattedDate, formattedTime };
  };

  const { formattedDate, formattedTime } = formatDate(reviewData?.reviewTime);

  const renderStars = (rating: number) => {
    const totalStars = 5;
    return Array.from({ length: totalStars }, (_, index) =>
      index < rating ? (
        <img key={index} src={Stars} alt="⭐" />
      ) : (
        <img key={index} src={NoStars} alt="☆" />
      )
    );
  };

  const [isViewerOpen, setViewerOpen] = useState(false);
  const [currentImage, setCurrentImage] = useState("");

  const closeViewer = () => {
    setViewerOpen(false);
  };

  const openViewer = (imageUrl: string) => {
    setCurrentImage(imageUrl);
    setViewerOpen(true);
  };

  const getAccountAge = (timestamp:any) => {
  const now = Date.now();
  const diff = now - timestamp;

  const days = Math.floor(diff / (1000 * 60 * 60 * 24));
  const years = Math.floor(days / 365);
  const months = Math.floor((days % 365) / 30);
  const remainingDays = days % 30;

  if (years > 0) return `${years}y ${months}m`;
  if (months > 0) return `${months}m ${remainingDays}d`;
  return `${days}d`;
};

const isReplyDisabled =
  reviewData?.status !== "approved" ||
  !Array.isArray(reviewData?.replies) ||
  reviewData.replies.length !== 0;



  return (
    <>
      <Card className="mainRatingCard">
            <ErrorModal
              show={showModal.isVisible}
              message={errorMessage}
              color={showModal.color}
              onCloseClick={() => setShowModal({ isVisible: false, color: false })}
            />
        <div className="OrderReviewMain d-flex gap-2">
         <input
              type="checkbox"
              className=" mb-auto"
              checked={props.selectedRows.includes(props?.reviews?._id)}
              onChange={(e) => {
                const checked = e.target.checked;
                const id = props?.reviews?._id;
                if (!id) return;

                if (checked) {
                  props.setSelectedRows((prev: any) => [...prev, id]);
                } else {
                  props.setSelectedRows((prev: any[]) => prev.filter(_id => _id !== id));
                }
              }}
            />
          <div className="w-100">
            <table>
              <tbody>
                <tr>
                  <td className="firstChildTD">
                    <div className="d-flex gap-2">
                      <div className="resMobileFir">
                        <div className="orderCard">
                          <div className="profile">
                            <img
                              src={reviewData.product?.productImage || boxRider}
                              alt=""
                            />
                          </div>
                          <div className="contentDv">
                            <h4 title={reviewData?.product?.productName}>{reviewData.product?.productName || "-"}</h4>

                            <div className="d-flex justify-content-start align-items-center gap-1">
                              <p className="sellerSku">
                                Order Item ID:{" "}
                                <span className="fw-bold">
                                  {reviewData?.product?._id || "-"}
                                </span>
                              </p>
                              <i
                                className="bx bx-copy text-secondary fs-6 fw-light cursor-pointer copy-icon"
                                data-testing-id="copyColor_order"
                                onClick={(event) => {
                                  event.stopPropagation();
                                  navigator.clipboard.writeText(
                                    reviewData?.product?._id
                                  );
                                  setShowModal({
                                    isVisible: true,
                                    color: true,
                                  });
                                  setErrorMessage("Order Id Copied!.");
                                  setTimeout(() => {
                                    setShowModal({
                                      isVisible: false,
                                      color: true,
                                    });
                                  }, 1000);
                                  return;
                                }}
                              ></i>
                            </div>
                          </div>
                        </div>
                        <div className="reviewDv mt-2">
                        <p className="ansDv mobile-hide">Overall Rating</p>
                        <div className="d-flex gap-1">
                          {renderStars(reviewData?.overallRating)}
                        </div>
                      </div>
                        <p className="timeDv mobile-hide">
                          Create Time:{" "}
                          <span className="date">{formattedDate}</span>{" "}
                          <span className="time">{formattedTime}</span>
                        </p>
                      </div>
                    </div>
                  </td>
                  <td className="SecondChildTD">
                    <div className="nameDv">
                      <img src={reviewData?.userProfilePicture?.url || profile} alt="" style={{width: "25px" , borderRadius: "50%"}} />
                      <p className="namee">{reviewData?.userName || "-"}</p>
                    </div>
                    <div className="itemDv mobile-hide">
                      <p className="headSide">Account Age:</p>
                      <p className="ansDv">
                         {props?.reviews?.accountAge
    ? getAccountAge(Number(props?.reviews?.accountAge))
    : "-"}
                      </p>
                    </div>
                    <div className="itemDv mobile-hide">
                      <p className="headSide">Total Reviews:</p>
                      <p className="ansDv">
                        {props?.reviews?.totalReviews || "0"}
                      </p>
                    </div>
                    <div className="itemDv mobile-hide">
                      <p className="headSide">Avg. Rating:</p>
                      <p className="ansDv">
                        {props?.reviews?.avgRating || "0"}/5
                      </p>
                    </div>
                  </td>
                  <td className="ThirdChildTD mobile-hide">
                    <div className="d-grid gap-2">
                      <div className="reviewDv">
                        <p className="ansDv">Overall Rating</p>
                        <div className="d-flex gap-1">
                          {renderStars(reviewData?.overallRating)}
                        </div>
                      </div>
                      <div className="reviewDv">
                        <p className="ansDv">Quality</p>
                        <div className="d-flex gap-1">
                          {renderStars(reviewData?.productQuality)}
                        </div>
                      </div>
                      <div className="reviewDv">
                        <p className="ansDv">Seller</p>
                        <div className="d-flex gap-1">
                          {renderStars(reviewData?.sellerService)}
                        </div>
                      </div>
                      <div className="reviewDv">
                        <p className="ansDv">Delivery</p>
                        <div className="d-flex gap-1">
                          {renderStars(reviewData?.deliveryService)}
                        </div>
                      </div>
                    </div>
                  </td>
                  <td className="FourthChildTD">
                    <div className="mediaDv">
                      {reviewData?.media?.length > 0 ? (
                        reviewData?.media?.map((item: any, index: number) => {
                          console.log(
                            `Media ${index} → Type: ${item.type}, URL: ${item.url}`
                          );

                          return item.type.toLowerCase() === "image" ? (
                            <img
                              key={index}
                              src={item.url}
                              alt={`media-${index}`}
                              onClick={() => openViewer(item.url)}
                              style={{ cursor: "pointer" }}
                            />
                          ) : (
                            <video key={index} controls>
                              <source
                                src={item.url}
                                type={item.metaData?.fileType || "video/mp4"}
                              />
                              Your browser does not support the video tag.
                            </video>
                          );
                        })
                      ) : (
                        <p style={{ fontSize: "10px" }}>No Media Found</p>
                      )}

                      <ImageViewer
                        isOpen={isViewerOpen}
                        imageUrl={currentImage}
                        toggle={closeViewer}
                      />
                    </div>
                  </td>
                  <td className="LastChildTD mobile-hide">
                    <div
                      className="d-flex justify-content-end gap-2"
                      onClick={props.onReply}
                    >
                      <button
                        className={`btn-reply ${
                          reviewData?.status === "pending" ||
                          reviewData?.status === "rejected" ||
                          reviewData?.status === "disputed" 
                          || isReplyDisabled
                            ? "btn-reply-disable"
                            : ""
                        }`}
                        disabled={
                          reviewData?.status === "pending" ||
                          reviewData?.status === "rejected" ||
                          reviewData?.status === "disputed" 
                          || isReplyDisabled
                        }
                      >
                        <img
                          src={
                            reviewData?.status === "pending" ||
                            reviewData?.status === "rejected" ||
                            reviewData?.status === "disputed" 
                            || isReplyDisabled
                              ? ChatDisable
                              : commentIcon
                          }
                          alt=""
                        />
                        Reply
                      </button>

                      {reviewData?.status !== "disputed" && (
                        <button
                          className="btn-red"
                          onClick={props.onDispute}
                          data-testing-id={
                            "dispute_OrderreviewCard" + props.index
                          }
                        >
                          Dispute
                        </button>
                      )}
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
            <div className="chatSide">
              <p className="chatDv">{reviewData?.review || "-"}</p>
            </div>
            {reviewData.replies && reviewData.replies.length > 0 ? (
              reviewData.replies.map(
                (
                  reply: { reply: string; createdOn: number },
                  index: number
                ) => {
                  const dateObj = new Date(reply.createdOn);
                  const formattedDate = dateObj.toLocaleDateString("en-GB", {
                    day: "2-digit",
                    month: "short",
                    year: "numeric",
                  });
                  const formattedTime = dateObj
                    .toLocaleTimeString("en-US", {
                      hour: "2-digit",
                      minute: "2-digit",
                      hour12: true,
                    })
                    .toLowerCase();

                  return (
                    <div className="DateSide" key={index}>
                      <a>{`${formattedDate} ${formattedTime}`}</a>
                      <p>{reply.reply}</p>
                    </div>
                  );
                }
              )
            ) : (
              <p>No replies yet.</p>
            )}

            <div className="MainStatus">
              <div className="d-flex gap-2 align-items-center mb-1">
                <h6 className="m-0">Dispute Submitted </h6>

                {reviewData?.status === "pending" && (
                  <div className="dekiveryType">
                    <div className="dot"></div>
                    <p style={{ textTransform: "capitalize" }}>Pending</p>
                  </div>
                )}

                {reviewData?.status === "approved" && (
                  <div className="dekiveryType Accepted">
                    <div className="dot"></div>
                    <p style={{ textTransform: "capitalize" }}>Accepted</p>
                  </div>
                )}

                {reviewData?.status === "disputed" && (
                  <div className="dekiveryType Disputed">
                    <div className="dot"></div>
                    <p style={{ textTransform: "capitalize" }}>Disputed</p>
                  </div>
                )}

                {reviewData?.status === "rejected" && (
                  <div className="dekiveryType Rejected">
                    <div className="dot"></div>
                    <p style={{ textTransform: "capitalize" }}>
                      {reviewData?.status || "-"}
                    </p>
                  </div>
                )}
              </div>
              <div
                className="statusSide"
                style={{ textTransform: "capitalize" }}
              >
                <p>{reviewData?.reason || "-"}</p>
              </div>
            </div>
            {reviewData?.moderationNotes?.trim() && (
              <div className="MainStatus">
                <div className="d-flex gap-2 align-items-center mb-1 mt-2">
                  <h6 className="m-0">Moderation Notes</h6>
                </div>
                <div
                  className="statusSide"
                  style={{ textTransform: "capitalize" }}
                >
                  <p>{reviewData.moderationNotes}</p>
                </div>
              </div>
            )}
            <div className="d-flex justify-content-between align-items-center gap-2 mt-3 buttonMain">
               <p className="timeDv mobile-show">
                          Create Time:{" "}
                          <span className="date">{formattedDate}</span>{" "}
                          <span className="time">{formattedTime}</span>
                        </p>
<div className="LastChildTD mobile-show">
  <div
                      className="d-flex justify-content-end gap-2 buttonSideCol"
                      onClick={props.onReply}
                    >
                      <button
                        className={`btn-reply ${
                          reviewData?.status === "pending" ||
                          reviewData?.status === "rejected" ||
                          reviewData?.status === "disputed" 
                          || isReplyDisabled
                            ? "btn-reply-disable"
                            : ""
                        }`}
                        disabled={
                          reviewData?.status === "pending" ||
                          reviewData?.status === "rejected" ||
                          reviewData?.status === "disputed" 
                          || isReplyDisabled
                        }
                      >
                        <img
                          src={
                            reviewData?.status === "pending" ||
                            reviewData?.status === "rejected" ||
                            reviewData?.status === "disputed" 
                            || isReplyDisabled
                              ? ChatDisable
                              : commentIcon
                          }
                          alt=""
                        />
                        Reply
                      </button>

                      {reviewData?.status !== "disputed" && (
                        <button
                          className="btn-red"
                          onClick={props.onDispute}
                          data-testing-id={
                            "dispute_OrderreviewCard" + props.index
                          }
                        >
                          Dispute
                        </button>
                      )}
              </div>
</div>
              
            </div>
          </div>
        </div>
      </Card>
    </>
  );
};

export default OrderReviewCard;
